"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateStr = exports.getLocalMidnight = exports.getLocalNoon = exports.formatRelativeMidSentence = exports.getLastNMonthStrings = exports.getLastNMonthDates = exports.getIntervalDates = exports.getLast12Months = exports.getYMKey = exports.monthRange = exports.createEndAt = exports.createStartOf = exports.daysUntil = exports.timeLeft = exports.daysHoursMinutesLeft = exports.getLongDate = exports.getMonthYear = exports.getMonthYearDate = exports.addDays = exports.addMinutes = void 0;
var end2end_1 = require("@hudled/end2end");
var date_fns_1 = require("date-fns");
var range_1 = __importDefault(require("lodash/range"));
var addMinutes = function (dt, minutes) { return (0, date_fns_1.add)(dt, { minutes: minutes }); };
exports.addMinutes = addMinutes;
var addDays = function (dt, days) { return (0, date_fns_1.add)(dt, { days: days }); };
exports.addDays = addDays;
var monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];
var WEEK_DAYS = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
];
var getMonthYearDate = function (date, shortMonth, shortYear) { return getMonthYear(date
    && { year: date.getFullYear(), month: date.getMonth() + 1 }, shortMonth, shortYear); };
exports.getMonthYearDate = getMonthYearDate;
function getMonthYear(yearMonth, shortMonth, shortYear) {
    if (!yearMonth)
        return '';
    var monthDate = shortMonth ? monthNames[yearMonth.month - 1].substring(0, 3) : monthNames[yearMonth.month - 1];
    var yearDate = shortYear ? yearMonth.year.toString().substring(2) : yearMonth.year;
    return "".concat(monthDate, " ").concat(yearDate);
}
exports.getMonthYear = getMonthYear;
function getLongDate(date, shortDay, shortMonth, shortYear) {
    var dOM = date.getDate();
    var dOW = shortDay
        ? WEEK_DAYS[date.getDay()].substring(0, 3)
        : WEEK_DAYS[date.getDay()];
    var monthDate = shortMonth
        ? monthNames[date.getMonth()].substring(0, 3)
        : monthNames[date.getMonth()];
    var yearDate = shortYear
        ? date.getFullYear().toString().substring(2)
        : date.getFullYear();
    return date.getDate() ? "".concat(dOW, ", ").concat(monthDate, " ").concat(dOM, ", ").concat(yearDate) : '';
}
exports.getLongDate = getLongDate;
var daysHoursMinutesLeft = function (untilDate) {
    var diffInMinutes = Math.ceil((+untilDate - Date.now()) / (60 * 1000));
    return {
        days: Math.floor(diffInMinutes / (24 * 60)),
        hours: Math.floor((diffInMinutes % (24 * 60)) / 60),
        minutes: diffInMinutes % 60,
    };
};
exports.daysHoursMinutesLeft = daysHoursMinutesLeft;
var timeLeft = function (untilDate) {
    var diffInMinutes = Math.ceil((+untilDate - Date.now()) / (60 * 1000));
    return {
        days: Math.floor(diffInMinutes / (24 * 60)),
        weeks: Math.floor(diffInMinutes / (7 * 24 * 60)),
        months: Math.floor(diffInMinutes / (30.41 * 24 * 60)),
    };
};
exports.timeLeft = timeLeft;
var daysUntil = function (endDate) { return endDate < new Date()
    ? 0
    : Math.round((+endDate - Date.now()) / end2end_1.MS_PER_DAY); };
exports.daysUntil = daysUntil;
// Date constructor takes months from 0 to 11
var createStartOf = function (yM) { return new Date(yM.year, yM.month - 1, 1); };
exports.createStartOf = createStartOf;
var createEndAt = function (yM) { return new Date(yM.year, yM.month, 1); };
exports.createEndAt = createEndAt;
var monthRange = function (yM) { return ({
    start: (0, exports.createStartOf)(yM),
    end: (0, exports.createEndAt)(yM),
}); };
exports.monthRange = monthRange;
var getYMKey = function (yM) { return "".concat(yM.year, "-").concat(yM.month); };
exports.getYMKey = getYMKey;
var getLast12Months = function () {
    var today = new Date();
    var thisMonth = today.getMonth() + 1;
    var thisYear = today.getFullYear();
    // Allow Date constructor's capacity of handling carry-overs to take care of edge cases
    return {
        start: (0, exports.createStartOf)({ year: thisYear - 1, month: thisMonth + 1 }),
        end: (0, exports.createEndAt)({ year: thisYear, month: thisMonth }),
    };
};
exports.getLast12Months = getLast12Months;
var PERIODS_BY_SIZE = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];
var getIntervalDates = function (start, end) {
    var duration = (0, date_fns_1.intervalToDuration)({ start: start, end: end });
    var biggestPeriod = PERIODS_BY_SIZE.find(function (period) { return duration[period]; }) || 'seconds';
    if (biggestPeriod === 'days' && duration.days && duration.days > 6) {
        return (0, end2end_1.handlePlural)('week')(Math.round(duration.days / 7));
    }
    if (['minutes', 'seconds'].includes(biggestPeriod)) {
        return '1 hour';
    }
    return (0, end2end_1.handlePlural)(biggestPeriod.replace(/s$/, ''))(duration[biggestPeriod]);
};
exports.getIntervalDates = getIntervalDates;
var getLastNMonthDates = function (n) { return (0, range_1.default)(n).map(function (months) { return (0, date_fns_1.sub)(new Date(), { months: months }); }).reverse(); };
exports.getLastNMonthDates = getLastNMonthDates;
var getLastNMonthStrings = function (n) { return (0, exports.getLastNMonthDates)(n).map(function (date) { return ((0, date_fns_1.format)(date, 'MMM yy')); }); };
exports.getLastNMonthStrings = getLastNMonthStrings;
var formatRelativeMidSentence = function (date, relativeTo) {
    var relStr = (0, date_fns_1.formatRelative)((0, end2end_1.toDate)(date), relativeTo !== null && relativeTo !== void 0 ? relativeTo : new Date());
    return relStr.match(/^(\d[\d/-]+\d$|[A-Z][a-z]+day at)/) ? "on ".concat(relStr) : relStr;
};
exports.formatRelativeMidSentence = formatRelativeMidSentence;
var getLocalNoon = function (dateStr) { return (new Date(+new Date("".concat(dateStr, "T12:00:00Z")) + new Date().getTimezoneOffset() * 60000)); };
exports.getLocalNoon = getLocalNoon;
var getLocalMidnight = function (dateStr) { return (new Date(+new Date("".concat(dateStr, "T00:00:00Z")) + new Date().getTimezoneOffset() * 60000)); };
exports.getLocalMidnight = getLocalMidnight;
var getDateStr = function (date) { return (0, end2end_1.getISODate)(new Date(+date - new Date().getTimezoneOffset() * 60000)); };
exports.getDateStr = getDateStr;
